import React from "react"

import { LogoutOverlayView } from "./LogoutOverlayView"
import { useLogoutViewModel } from "./hooks/useLogoutViewModel"

export const LogoutOverlay = React.memo(() => (
  <LogoutOverlayView {...useLogoutViewModel()} />
))

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    LOGOUT_OVERLAY: null
  }
}
